import { render, staticRenderFns } from "./type_of_work_charts_loader.vue?vue&type=template&id=c5a64a42"
import script from "./type_of_work_charts_loader.vue?vue&type=script&lang=js"
export * from "./type_of_work_charts_loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports